import {useSelector} from "react-redux";
import _ from "lodash";

export default function (msgDataSourceId) {
    const customFieldList = useSelector(state => state.customField.fetchedCustomFields);
    const fetchCustomFieldsLoading = useSelector(state => state.customField.fetchCustomFieldsLoading);

    function getCustomFieldsByDataSource(data, masDataSourceId) {
        if (!masDataSourceId) {
            console.error("masDataSourceId is required to fetch the customFields");
            return [];
        }
        const result = data.find(entry => entry.masDataSourceId === masDataSourceId);
        return result ? result.customFields : [];
    }

    const customFields = getCustomFieldsByDataSource(customFieldList, msgDataSourceId);
    return {customFields, fetchCustomFieldsLoading};
}